"use client";

import { Button } from "@/components/ui/button";
import Input from "@/components/ui/input";
import { useScopedI18n } from "@/messages/client";
import { Column } from "@tanstack/react-table";
import { useDebounce } from "ahooks";
import { useEffect, useState } from "react";

export default function TextFilter<T>({
  column,
}: {
  column: Column<T, unknown>;
}) {
  const t = useScopedI18n("选型器");

  const [search, setSearch] = useState(
    (column.getFilterValue() as string) || ""
  );

  const debouncedValue = useDebounce(search, { wait: 300 });

  useEffect(() => {
    column.setFilterValue(debouncedValue);
  }, [debouncedValue, column]);

  return (
    <div className="flex flex-col">
      <div className="flex w-full flex-col">
        <div className="mb-3 mt-4 px-4 md:flex md:items-center md:px-6">
          <div className="relative flex flex-1 items-center">
            <Input
              inputSize="sm"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="h-full w-full rounded-sm bg-white px-1 text-xs outline-none transition-colors duration-300 focus:border-primary"
              placeholder={t("筛选")}
            />
          </div>
        </div>
      </div>
      <div className="px-4 py-2 md:py-4">
        <Button
          className="h-auto p-0 text-sm font-normal text-primary hover:bg-transparent"
          variant="ghost"
          onClick={() => {
            setSearch("");
            column.setFilterValue("");
          }}>
          {t("复位")}
        </Button>
      </div>
    </div>
  );
}
